import Cookies from 'js-cookie';
import { App } from '@capacitor/app';
import { platformWeb } from './utils/platform';

let cachedBundleId: string | null = null;

//initializeBundleId function to set the bundle id cookie
export const initializeBundleId = async () => {
  try {
    const info = await App.getInfo();
    const bundleId = info.id;
    cachedBundleId = bundleId;
  } catch (error) {
    if (platformWeb()) {
      console.log('No bundle id in web');
    } else {
      console.error('Error getting bundle id from App API', error);
    }
  }
};

const getBundleIdCookie = (): string => {
  const cookie = Cookies.get('bundleId');

  if (cookie) {
    return cookie;
  } else if (cachedBundleId) {
    console.error('Bundle ID cookie not found, using cached value.');
    return cachedBundleId;
  }

  if (!platformWeb()) {
    console.error('Bundle ID not initialized. returning fallback.');
  }
  initializeBundleId();

  return 'com.metro.ride.dev'; // Fallback value
};

export default getBundleIdCookie;
